(function () {
  'use strict';

  angular.module('app').component('creditNotePage', creditNoteDetailCtrl());

  function creditNoteDetailCtrl() {
    return {
      bindings: {},
      controller: CreditNoteDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/credit-notes/credit-note-page.component.html',
    };
  }

  CreditNoteDetailCtrl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'CreditNoteService',
  ];

  function CreditNoteDetailCtrl($location, $routeParams, AbilityService, CreditNoteService) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_creditnote_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.mode = $routeParams.mode;

    // Methods
    vm.onSavedItem = onSavedItem;
    vm.onCanceledItem = onCanceledItem;

    // Initializers
    getItem();

    function getItem() {
      if (itemId) {
        vm.loadingItem = true;
        CreditNoteService.getCreditNote(itemId).then(function (data) {
          vm.creditNote = data;

          vm.loadingItem = false;
        });
      } else {
        vm.creditNote = {};
      }
    }

    function onSavedItem(item) {
      $location.path(`/credit_notes/${item.id}`);
    }

    function onCanceledItem() {
      $location.path('/credit_notes');
    }
  }
})();
